import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    Grid,

} from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { SettingContext } from "context/SettingContext";
import { useGlobalContext } from 'context/GlobalContext';
import { useMeltingRequestDetail } from '../API/meltingrequestapi';


import ProductSkeleton from 'components/ui/Skeleton/ProductSkeleton';
import useStockInCatalog from 'hooks/useStockInCatalog';
import { useDispatch } from 'react-redux';
import { addEditCategory, removeEditCategory } from 'store/cartSlice';

import MeltingRequestProduct from './Product';



const MeltingRequestDetail = () => {
    const { meltingRequestId } = useParams();
    // console.log("id ahe",id);

    const navigate = useNavigate();
    const location = useLocation();
    // console.log("Nelting location", location)
    const { requestData } = location.state || {};

    // const [selectedProductIds, setSelectedProductIds] = useState([]);
    const { setSearchBar, search } = useContext(SettingContext);
    const { setSearchPlaceHolder,
        setFilterChangeCount,
        setDisplayCount,
        setSearchResultCount,
        dynamicfilterCount,
        setDynamicFilterCount,
        filterChangeCount,
        setMeltingStatus,
        setMeltingProducts,
        setActivateFinalise
    } = useGlobalContext();

    const dispatch = useDispatch();




    const mode = location.state?.mode;

    const payload = {
        melting_req_id: meltingRequestId,
        searchBy: search,
        ...(location?.state?.status === "Finalise" && { meltingRequestStatus: "Finalise" })
    }

    const { data: meltingDesignData, isLoading, isError, error, } = useMeltingRequestDetail(payload);
    // console.log("datatatat",id);

    const data = meltingDesignData?.data;
    // console.log("datatatat", data);

    // const { setBtnTitle, btnTilte } = useStockInCatalog(product);


    // data should now be the array from res.data.result.data
    // console.log("Products data:", data);

    // const handleSelectProduct = (product) => {
    //     let newSelectedIds;

    //     if (selectedProductIds.includes(product.jewelId || product._id)) {
    //         newSelectedIds = selectedProductIds.filter(id => id !== (product.jewelId || product._id));
    //     } else {
    //         newSelectedIds = [...selectedProductIds, (product.jewelId || product._id)];
    //     }

    //     setSelectedProductIds(newSelectedIds);

    //     const selectedProducts = Array.isArray(data) 
    //         ? data.filter(p => newSelectedIds.includes(p.jewelId || p._id)) 
    //         : [];
    //     updateMeltingSelections(selectedProducts);
    // };

    // const handleSelectProduct = (product) => {
    //     dispatch(
    //         addEditCategory({
    //             storageKey: "removeMeltingDesign",
    //             data: {
    //                 _id: product?._id || product?.id,
    //                 styleNumber: product?.styleNumber,
    //             },
    //         })
    //     );
    //     setBtnTitle("Selected");
    // };

    // const handleRemoveProduct = React.useCallback(
    //     (productToRemove) => {
    //         setBtnTitle("Select");

    //         dispatch(
    //             removeEditCategory({
    //                 storageKey: "removeMeltingDesign",
    //                 id: productToRemove.id || productToRemove._id,
    //             })
    //         );
    //     },
    //     [dispatch, setBtnTitle]
    // );


    // const getSelectedCartProducts = () => {
    //     return Array.isArray(data) 
    //         ? data.filter(product => selectedProductIds.includes(product.jewelId || product._id)) 
    //         : [];
    // };

    // useEffect(() => {
    //     const selectedProducts = Array.isArray(data) 
    //         ? data.filter(p => selectedProductIds.includes(p.jewelId || p._id)) 
    //         : [];
    //     updateMeltingSelections(selectedProducts);
    // }, [selectedProductIds, data]);

    // Export Jewel Code 
    useEffect(() => {
        if (Array.isArray(data)) {
            setMeltingProducts(data);
        }
    }, [data]);

    useEffect(() => {
        setSearchBar(true);
        setSearchPlaceHolder("Search By Jewel Code or Design Number");
    }, [])

    useEffect(() => {
        if (!Array.isArray(data)) return;

        const isOnlyHQ = data?.every(item => item.location === "Headquarters Stock");
        setActivateFinalise(isOnlyHQ);

        if (search === "") {
            setDynamicFilterCount(true);
        }
        if (dynamicfilterCount) {
            setFilterChangeCount(data.length);
            setSearchResultCount(data.length);
        } else {
            setSearchResultCount(data.length);
            setFilterChangeCount(filterChangeCount);
        }
        setDisplayCount(true);
        setMeltingStatus(meltingDesignData?.statusTimeline)
        return () => {
            setSearchResultCount(0);
            setFilterChangeCount(0);
            setDisplayCount(false);
            setMeltingStatus("");
            setActivateFinalise(false);
        };
    }, [meltingDesignData, data]);

    if (isLoading) return <ProductSkeleton count={10} />;
    if (isError) return <p>Error loading details</p>;
    if (!Array.isArray(data) || data.length === 0) return <p>No products found</p>;

    return (
        <Box sx={{
            p: 4,
            backgroundColor: '#000',
            color: '#fff',
            fontFamily: 'Karla'
        }}>

            <Grid container spacing={4} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {data.map((product) => {

                    return <MeltingRequestProduct product={product} key={product.id} />;


                })}
            </Grid>
        </Box>
    );
};

export default MeltingRequestDetail;